module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 11-996701fe740cc045ff05ab5b5f3bf85d.webp";